import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { useState } from 'react';
import { SortObj } from '../types';

const useSortObj = (sortObj: SortObj) => {
  const {
    snippetsSortDirection: sortDirection = SORT_DIRECTIONS.DESCENDING,
    snippetsSortedBy: sortBy,
    setSnippetsSortedBy: setSortBy,
    setSnippetsSortDirection: setSortDirection,
  } = sortObj;
  const handleSort = (col = 'TotalSent') => {
    if (col === sortBy) {
      const direction =
        sortDirection === SORT_DIRECTIONS.ASCENDING
          ? SORT_DIRECTIONS.DESCENDING
          : SORT_DIRECTIONS.ASCENDING;
      setSortDirection(direction);
    } else {
      setSortBy(col);
      setSortDirection(SORT_DIRECTIONS.ASCENDING);
    }
  };
  return { sortBy, sortDirection, handleSort };
};

export const useSort = (sortObj?: SortObj) => {
  if (sortObj) {
    return useSortObj(sortObj);
  }
  const [sortBy, setSortBy] = useState('TotalSent');
  const [sortDirection, setSortDirection] = useState(SORT_DIRECTIONS.DESCENDING);

  const handleSort = (col: string) => {
    if (col === sortBy) {
      const direction =
        sortDirection === SORT_DIRECTIONS.ASCENDING
          ? SORT_DIRECTIONS.DESCENDING
          : SORT_DIRECTIONS.ASCENDING;
      setSortDirection(direction);
    } else {
      setSortBy(col);
      setSortDirection(SORT_DIRECTIONS.ASCENDING);
    }
  };

  return { sortBy, sortDirection, handleSort };
};
